<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style>
#app {
  left: 0;
  min-height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
